/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const retireMonitoringIntegrationBodyExpectedVersionExclusiveMin = 0;
export const retireMonitoringIntegrationBodyExpectedVersionMax = 9007199254740991;

export const RetireMonitoringIntegrationBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(retireMonitoringIntegrationBodyExpectedVersionExclusiveMin)
    .max(retireMonitoringIntegrationBodyExpectedVersionMax),
  confirmed: zod.literal(true),
});

export type RetireMonitoringIntegrationBody = zod.input<typeof RetireMonitoringIntegrationBody>;
export type RetireMonitoringIntegrationBodyOutput = zod.output<
  typeof RetireMonitoringIntegrationBody
>;
